// TanStack Queryのクエリキー定数
export const QUERY_KEYS = {
  PDF: {
    LATEST: ['pdf', 'latest'] as const,
    ERROR: ['pdf', 'error'] as const,
    GENERATION: ['pdf', 'generation'] as const,
  },
} as const;

// PDF生成関連の定数
export const REFRESH_TIME = 500;
